import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { WeighbridgeTicket } from '../../../store/entities/weighbridge/weighbridge.types';
import { APIManagerConfig } from '../apiManager';

const WeeighbridgeServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => ({
  getWeighbridgeTickets: (
    status = 'open',
    endDate = new Date().toJSON(),
    daysBack = 9999,
  ): Promise<WeighbridgeTicket[]> => {
    return HTTPBase.get(
      `farm/${config.farmId}/weighbridge/tickets?status=${status}${daysBack ? `&daysBack=${daysBack}` : ''}${
        endDate ? `&endDate=${endDate}` : ''
      }`,
    ).then((res) => res.data);
  },
  getWeighbridgeTicket: (weighBridgeTicketId: string): Promise<WeighbridgeTicket[]> => {
    return HTTPBase.get(`farm/${config.farmId}/weighbridge/tickets/${weighBridgeTicketId}`).then((res) => res.data);
  },
  getWeighbridgeTicketTransactions: (stockTransactionItemId: string) => {
    return HTTPBase.get(
      `farm/${config.farmId}/weighbridge/tickets?stockTransactionItemId=${stockTransactionItemId}`,
    ).then((res) => res.data);
  },
  createWeighbridgeTicket: (
    payload: Partial<WeighbridgeTicket>,
    noSave: boolean,
    formName: FormName,
  ): Promise<WeighbridgeTicket> => {
    return HTTPBase.post(`farm/${config.farmId}/weighbridge/tickets?noSave=${noSave}`, payload, {
      headers: { formName },
    }).then((res) => res.data);
  },
  updateWeighbridgeTicket: (
    weighBridgeTicketId: string,
    payload: Partial<WeighbridgeTicket>,
    noSave: boolean,
    formName?: FormName,
  ): Promise<WeighbridgeTicket> => {
    return HTTPBase.patch(
      `farm/${config.farmId}/weighbridge/tickets/${weighBridgeTicketId}?noSave=${noSave}`,
      payload,
      {
        headers: { formName },
      },
    ).then((res) => res.data);
  },
  deleteWeighbridgeTicket: (weighBridgeTicketId: string, formName?: FormName): Promise<any> => {
    return HTTPBase.delete(`farm/${config.farmId}/weighbridge/tickets/${weighBridgeTicketId}`, {
      headers: { formName },
    }).then((res) => res.data);
  },
  deleteMultipleWeighbridgeTickets: (weighBridgeTicketIds: string[], formName?: FormName): Promise<any> => {
    return HTTPBase.delete(
      `farm/${config.farmId}/weighbridge/tickets?weighbridgeticketids=${weighBridgeTicketIds.join()}`,
    );
  },
});

export default WeeighbridgeServiceFactory;
